import Image from 'next/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('about');

const HeadQuarters = () => (
  <section className="flex flex-col items-center justify-center overflow-hidden bg-[#F5FFFF] py-10 text-center sm:py-16">
    <h2 className="text-xl font-bold leading-tight md:text-2xl">
      {t`Global Office Locations`}
    </h2>
    <h3 className="text-base">{t`Headquarters: San Mateo, California`}</h3>
    <div className="mt-10 w-[140%] md:w-[115%] xl:w-full">
      <Image
        src={getEdgeUrl('images/about-us/head-quarters/map.png')}
        alt={t`Office Location`}
        width={2880}
        height={1061}
        className="h-auto w-full"
        quality={100}
        loading="eager"
      />
    </div>
  </section>
);

export default HeadQuarters;
